module.exports = __webpack_public_path__ + "img/16.53c74f0c.svg";